module.exports = __webpack_public_path__ + "img/product_10.efcf223.jpg";